import { GET_FLOORS_API } from '../commons/constants/apis';
import { ResponseTypes } from '../types/response/common';
import { FloorResponseTypes } from '../types/response/floor';
import axios from './axios';

export const getFloorByIds = async (
  ids: number[],
  language: string
): Promise<FloorResponseTypes[]> => {
  const { data }: ResponseTypes<FloorResponseTypes[]> = await axios.get(`${GET_FLOORS_API}`, {
    params: { includeIds: ids.join(',') },
    headers: { language },
  });
  return data;
};

export const getFloorById = async (id: number, language: string): Promise<FloorResponseTypes> => {
  const { data }: ResponseTypes<FloorResponseTypes> = await axios.get(
    `${GET_FLOORS_API}/${id}/id`,
    {
      headers: { language },
    }
  );
  return data;
};
